import type { FillPattern } from "@msuite/utils/schemas";

export function getPatternId(type: FillPattern, salt: string) {
	return `url(#${salt}-${type}Pattern)`;
}
